import { Button, Container, Col, Row } from 'reactstrap'
import React from 'react'
import { Link, useHistory } from 'react-router-dom'

import CartWhiteIcon from '../../../assets/img/icons/SHOPPING_WHITE.svg'
import CartIcon from '../../../assets/img/icons/SHOPPING.svg'
import Icon from '../../../components/Icons/Icon'

import './Cart.css'

import CartItem from './CartItem/CartItem'
import { useDispatch, useSelector } from 'react-redux'
import {
    removeFromCart,
    updateCartMeterage,
} from '../../../redux/payment/actions'
import PaymentSidebar from '../Sidebar/PaymentSidebar'
import { isEmpty } from 'lodash'

const Cart = () => {
    const dispatch = useDispatch()

    const cartItems = useSelector((state) => state.payment.cart)

    const history = useHistory()

    const onRemoveCartItem = (id) => {
        dispatch(removeFromCart(id))
    }
    const onCartItemEdited = (id, newMeterage) => {
        dispatch(updateCartMeterage(id, newMeterage))
    }

    return (
        <div className="cart">
            <h3 className="cart__header">
                <Icon src={CartWhiteIcon} size="xlg" />
                سبد خرید
            </h3>
            <div className="cart__header-wrapper">
                <Button
                    className="d-flex align-items-center"
                    color="link"
                    onClick={() => history.goBack()}
                >
                    <span className="back-icon">&lsaquo;</span>بازگشت
                </Button>
            </div>
            <Container>
                <Row>
                    <Col md={2}></Col>
                    <Col className="cart__items" md={7}>
                        {isEmpty(cartItems) && (
                            <h3 className="text-center text-white m-3">
                                سبد خرید شما خالی است.
                            </h3>
                        )}

                        {cartItems.map((cart, index) => (
                            <CartItem
                                key={index}
                                {...cart}
                                onRemove={onRemoveCartItem}
                                onEdited={onCartItemEdited}
                            />
                        ))}
                    </Col>
                    {!isEmpty(cartItems) && (
                        <Col className="cart__sidebar" md={3}>
                            <PaymentSidebar>
                                <Link to="/payment">
                                    <Button className="payment-sidebar__add-to-cart-btn">
                                        <Icon src={CartIcon} size="xlg" />
                                        نهایی کردن خرید
                                    </Button>
                                </Link>
                            </PaymentSidebar>
                        </Col>
                    )}
                </Row>
            </Container>
        </div>
    )
}

export default Cart
